"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const BaseController_1 = __importDefault(require("./BaseController"));
const AuthService_1 = __importDefault(require("../services/AuthService"));
class ContactTracingApi extends BaseController_1.default {
    constructor() {
        super();
        this.fetchRoles = () => __awaiter(this, void 0, void 0, function* () {
            let response = yield fetch(`${this.url_contact_tracing}/roles`, yield this.requestHeaderGet());
            if (response.status == 200) {
                let data = yield response.json();
                return { items: data };
            }
            else {
                return {
                    error: true,
                };
            }
        });
        this.fetchCases = (dsl, status_id) => __awaiter(this, void 0, void 0, function* () {
            let response;
            if (dsl) {
                response = yield fetch(`${this.url_contact_tracing}?dsl=${dsl}${status_id ? `&status_id=${status_id}` : ""}`, yield this.requestHeaderGet());
            }
            else {
                response = yield fetch(`${this.url_contact_tracing}${status_id ? `?status_id=${status_id}` : ""}`, yield this.requestHeaderGet());
            }
            if (response.status == 200) {
                let data = yield response.json();
                return { items: data };
            }
            else {
                return {
                    error: true,
                };
            }
        });
        this.fetchClasses = (mitId) => __awaiter(this, void 0, void 0, function* () {
            let response = yield fetch(`${this.url_classes}?mitId=${mitId}`, yield this.requestHeaderGet());
            if (this.checkStatusCode(response.status)) {
                let data = yield response.json();
                return data;
            }
            else {
                const text = yield response.json();
                return yield Promise.reject(text.message);
            }
        });
        this.fetchClassMembers = (classIdentifier, mitId, caseGuid, code, number, term, unvaccinatedOnly) => __awaiter(this, void 0, void 0, function* () {
            let response = yield fetch(`${this.url_classes}/${encodeURI(classIdentifier)}/members?mitId=${mitId}&caseGuid=${caseGuid}&code=${code}&number=${number}&term=${term}&unvaccinatedOnly=${unvaccinatedOnly !== null && unvaccinatedOnly !== void 0 ? unvaccinatedOnly : false}`, yield this.requestHeaderGet());
            if (this.checkStatusCode(response.status)) {
                let data = yield response.json();
                return data;
            }
            else {
                const text = yield response.json();
                return yield Promise.reject(text.message);
            }
        });
        this.fetchStatus = () => __awaiter(this, void 0, void 0, function* () {
            let response = yield fetch(`${this.url_contact_tracing_status}`, yield this.requestHeaderGet());
            if (response.status == 200) {
                let data = yield response.json();
                return { items: data };
            }
            else {
                return {
                    error: true,
                };
            }
        });
        this.fetchAudit = (mit_id) => __awaiter(this, void 0, void 0, function* () {
            let response = yield fetch(`${this.url_audit}?mit_id=${mit_id}`, yield this.requestHeaderGet());
            if (response.status == 200) {
                let data = yield response.json();
                return { items: data };
            }
            else if (response.status === 507 || response.status === 403) {
                return {
                    unauth: true,
                };
            }
            else {
                return {
                    error: true,
                };
            }
        });
        this.fetchContact = (case_guid) => __awaiter(this, void 0, void 0, function* () {
            let response = yield fetch(`${this.url_contact_tracing}/${case_guid}/contact`, yield this.requestHeaderGet());
            if (response.status === 200) {
                let data = yield response.json();
                return { items: data };
            }
            else {
                return {
                    error: true,
                };
            }
        });
        this.fetchComments = (case_guid) => __awaiter(this, void 0, void 0, function* () {
            let response = yield fetch(`${this.url_contact_tracing}/${case_guid}/comments`, yield this.requestHeaderGet());
            if (response.status === 200) {
                let data = yield response.json();
                return { items: data };
            }
            else {
                return {
                    error: true,
                };
            }
        });
        this.fetchContactComments = (case_guid, contact_guid) => __awaiter(this, void 0, void 0, function* () {
            let response = yield fetch(`${this.url_contact_tracing}/${case_guid}/${contact_guid}/comments`, yield this.requestHeaderGet());
            if (response.status === 200) {
                let data = yield response.json();
                return { items: data };
            }
            else {
                return {
                    error: true,
                };
            }
        });
        this.fetchBuildings = () => __awaiter(this, void 0, void 0, function* () {
            let response = yield fetch(this.url_buildings, yield this.requestHeaderGet());
            if (response.status === 200) {
                let data = yield response.json();
                return { items: data };
            }
            else {
                return {
                    error: true,
                };
            }
        });
        this.fetchLocations = () => __awaiter(this, void 0, void 0, function* () {
            let response = yield fetch(this.url_locations, yield this.requestHeaderGet());
            if (response.status === 200) {
                let data = yield response.json();
                return { items: data };
            }
            else {
                return {
                    error: true,
                };
            }
        });
        this.fetchContactQuestions = (mit_id, case_guid, contact_guid) => __awaiter(this, void 0, void 0, function* () {
            let url = `${this.url_contact_tracing_questions}/${case_guid}`;
            url = url += !!contact_guid ? `?ct_contact_guid=${contact_guid}` : "";
            let response = yield fetch(url, yield this.requestHeaderGet());
            if (response.status == 200) {
                let data = yield response.json();
                return { items: data };
            }
            else if (response.status === 507 || response.status === 403) {
                return {
                    unauth: true,
                };
            }
            else {
                return {
                    error: true,
                };
            }
        });
        this.fetchContactQuestionPersonTypes = () => __awaiter(this, void 0, void 0, function* () {
            let response = yield fetch(`${this.url_contact_tracing_questions}/person_type`, yield this.requestHeaderGet());
            if (response.status == 200) {
                let data = yield response.json();
                return { items: data };
            }
            else if (response.status === 507 || response.status === 403) {
                return {
                    unauth: true,
                };
            }
            else {
                return {
                    error: true,
                };
            }
        });
        this.fetchContactQuestionExposureTypes = () => __awaiter(this, void 0, void 0, function* () {
            let response = yield fetch(`${this.url_contact_tracing_questions}/exposure_type`, yield this.requestHeaderGet());
            if (response.status == 200) {
                let data = yield response.json();
                return { items: data };
            }
            else if (response.status === 507 || response.status === 403) {
                return {
                    unauth: true,
                };
            }
            else {
                return {
                    error: true,
                };
            }
        });
        this.fetchContactQuestionTestStreamTypes = () => __awaiter(this, void 0, void 0, function* () {
            let response = yield fetch(`${this.url_contact_tracing_questions}/testing_stream_type`, yield this.requestHeaderGet());
            if (response.status == 200) {
                let data = yield response.json();
                return { items: data };
            }
            else if (response.status === 507 || response.status === 403) {
                return {
                    unauth: true,
                };
            }
            else {
                return {
                    error: true,
                };
            }
        });
        this.url_contact_tracing = `${this.apiHost}/${this.apiPathMedical}/contact_tracing`;
        this.url_contact_tracing_status = `${this.apiHost}/${this.apiPathMedical}/contact_tracing/status`;
        this.url_contact_tracing_questions = `${this.apiHost}/${this.apiPathMedical}/contact_tracing/question_medical`;
        this.url_audit = `${this.apiHost}/${this.apiPathMedical}/audit`;
        this.url_buildings = `${this.apiHost}/${this.apiPathMedical}/buildings`;
        this.url_locations = `${this.apiHost}/${this.apiPathMedical}/checkin/locations`;
        this.url_classes = `${this.apiHost}/${this.apiPathMedical}/classes`;
    }
    updateContactQuestions(case_guid, answers, contact_guid) {
        return __awaiter(this, void 0, void 0, function* () {
            let token = yield AuthService_1.default.getToken();
            const postOptions = {
                method: "PUT",
                headers: new Headers({
                    Authorization: "Bearer " + token,
                    "Content-Type": "application/json",
                }),
                body: JSON.stringify(answers),
            };
            let url = `${this.url_contact_tracing_questions}/${case_guid}`;
            url = url += !!contact_guid ? `?ct_contact_guid=${contact_guid}` : "";
            let response = yield fetch(url, postOptions);
            if (response.status === 200 || response.status === 201) {
                let data = yield response.json();
                return { items: data };
            }
            else if (response.status === 507 || response.status === 403) {
                return {
                    unauth: true,
                };
            }
            else {
                return {
                    error: true,
                };
            }
        });
    }
    deleteContactQuestions(case_guid, body) {
        return __awaiter(this, void 0, void 0, function* () {
            let token = yield AuthService_1.default.getToken();
            const deleteOptions = {
                method: "DELETE",
                headers: new Headers({
                    Authorization: "Bearer " + token,
                    "Content-Type": "application/json",
                }),
                body: JSON.stringify(body),
            };
            let response = yield fetch(`${this.url_contact_tracing}/${case_guid}`, deleteOptions);
            if (response.status === 200) {
                let data = yield response.json();
                return { items: data };
            }
            else {
                return { error: true };
            }
        });
    }
    postCase(body) {
        return __awaiter(this, void 0, void 0, function* () {
            let token = yield AuthService_1.default.getToken();
            const postOptions = {
                method: "POST",
                headers: new Headers({
                    Authorization: "Bearer " + token,
                    "Content-Type": "application/json",
                }),
                body: JSON.stringify(body),
            };
            let response = yield fetch(this.url_contact_tracing, postOptions);
            if (response.status === 200 || response.status === 201) {
                let data = yield response.json();
                return { items: data };
            }
            else {
                return { error: true };
            }
        });
    }
    postContact(case_guid, body) {
        return __awaiter(this, void 0, void 0, function* () {
            let token = yield AuthService_1.default.getToken();
            const postOptions = {
                method: "POST",
                headers: new Headers({
                    Authorization: "Bearer " + token,
                    "Content-Type": "application/json",
                }),
                body: JSON.stringify(body),
            };
            let response = yield fetch(this.url_contact_tracing + `/${case_guid}/contact`, postOptions);
            if (response.status === 200 || response.status === 201) {
                let data = yield response.json();
                return { items: data };
            }
            else {
                return { error: true };
            }
        });
    }
    postComment(case_guid, message) {
        return __awaiter(this, void 0, void 0, function* () {
            let body = {
                comment: message,
            };
            let token = yield AuthService_1.default.getToken();
            const postOptions = {
                method: "POST",
                headers: new Headers({
                    Authorization: "Bearer " + token,
                    "Content-Type": "application/json",
                }),
                body: JSON.stringify(body),
            };
            let response = yield fetch(this.url_contact_tracing + `/${case_guid}/comments`, postOptions);
            if (response.status === 200 || response.status === 201) {
                let data = yield response.json();
                return { items: data };
            }
            else if (response.status === 507 || response.status === 403) {
                return {
                    unauth: true,
                };
            }
            else {
                return { error: true };
            }
        });
    }
    postContactComment(case_guid, contact_guid, message) {
        return __awaiter(this, void 0, void 0, function* () {
            let body = {
                comment: message,
            };
            let token = yield AuthService_1.default.getToken();
            const postOptions = {
                method: "POST",
                headers: new Headers({
                    Authorization: "Bearer " + token,
                    "Content-Type": "application/json",
                }),
                body: JSON.stringify(body),
            };
            let response = yield fetch(this.url_contact_tracing + `/${case_guid}/${contact_guid}/comments`, postOptions);
            if (response.status === 200 || response.status === 201) {
                let data = yield response.json();
                return { items: data };
            }
            else if (response.status === 507 || response.status === 403) {
                return {
                    unauth: true,
                };
            }
            else {
                return { error: true };
            }
        });
    }
    putCaseStatus(case_guid, status_id, status_name) {
        return __awaiter(this, void 0, void 0, function* () {
            let body = {
                status_id: status_id,
                status_name: status_name,
            };
            let token = yield AuthService_1.default.getToken();
            const putOptions = {
                method: "PUT",
                headers: new Headers({
                    Authorization: "Bearer " + token,
                    "Content-Type": "application/json",
                }),
                body: JSON.stringify(body),
            };
            let response = yield fetch(this.url_contact_tracing + `/${case_guid}/status`, putOptions);
            if (response.status === 200) {
                let data = yield response.json();
                return { items: data };
            }
            else {
                return { error: true };
            }
        });
    }
    putContact(case_guid, body) {
        return __awaiter(this, void 0, void 0, function* () {
            let token = yield AuthService_1.default.getToken();
            const putOptions = {
                method: "PUT",
                headers: new Headers({
                    Authorization: "Bearer " + token,
                    "Content-Type": "application/json",
                }),
                body: JSON.stringify(body),
            };
            let response = yield fetch(this.url_contact_tracing + `/${case_guid}/contact`, putOptions);
            if (response.status === 200) {
                let data = yield response.json();
                return { items: data };
            }
            else {
                return { error: true };
            }
        });
    }
    deleteContact(case_guid, body) {
        return __awaiter(this, void 0, void 0, function* () {
            let token = yield AuthService_1.default.getToken();
            const deleteOptions = {
                method: "DELETE",
                headers: new Headers({
                    Authorization: "Bearer " + token,
                    "Content-Type": "application/json",
                }),
                body: JSON.stringify(body),
            };
            let response = yield fetch(this.url_contact_tracing + `/${case_guid}/contact`, deleteOptions);
            if (response.status === 200) {
                let data = yield response.json();
                return { items: data };
            }
            else {
                return { error: true };
            }
        });
    }
}
const contactTracingApi = new ContactTracingApi();
exports.default = contactTracingApi;
